var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.lista.place)?[(_vm.teatro.sga)?_c('ProcesoCompraAbonadosSga',{ref:"cambioRuta"}):(_vm.manager.lfp && _vm.url.includes('test=true'))?_c('ProcesoCompraAbonadoLfp'):_c('ProcesoCompraAbonadoNormal')]:_c('ProcesoCompraAbonadosSinRecinto')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }